export enum HonorariumType {
    HoraAberta = 1,
    HoraFechada = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/HonorariumType.ts